var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionLeaveNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0H1.6C.72 0 0 .72 0 1.6V16l3.2-3.2h11.2c.88 0 1.6-.72 1.6-1.6V1.6c0-.88-.72-1.6-1.6-1.6zM5.6 7.2H4V5.6h1.6v1.6zm3.2 0H7.2V5.6h1.6v1.6zm3.2 0h-1.6V5.6H12v1.6z",
    fill: "#323232"
  })));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTVRZaUlHaGxhV2RvZEQwaU1UWWlJSFpwWlhkQ2IzZzlJakFnTUNBeE5pQXhOaUlnWm1sc2JEMGlibTl1WlNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWo0S1BIQmhkR2dnWkQwaVRURTBMalFnTUVneExqWkRNQzQzTWlBd0lEQWdNQzQzTWlBd0lERXVObFl4Tmt3ekxqSWdNVEl1T0VneE5DNDBRekUxTGpJNElERXlMamdnTVRZZ01USXVNRGdnTVRZZ01URXVNbFl4TGpaRE1UWWdNQzQzTWlBeE5TNHlPQ0F3SURFMExqUWdNRnBOTlM0MklEY3VNa2cwVmpVdU5rZzFMalpXTnk0eVdrMDRMamdnTnk0eVNEY3VNbFkxTGpaSU9DNDRWamN1TWxwTk1USWdOeTR5U0RFd0xqUldOUzQyU0RFeVZqY3VNbG9pSUdacGJHdzlJaU16TWpNeU16SWlMejRLUEM5emRtYytDZz09Ig==";
export { SvgActionLeaveNote as ReactComponent };